import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { RainUploadProgress } from '../../models/rain-upload-progress';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RainUploadQueryProgressService {

  /** Caminho da URL  */
  uploadProgressPath = 'rain-upload-progress';

  /** Caminho da rota de marcar a mensagem de resultado do upload como vista. */
  updateUploadMessageUrl = `${environment.serverBaseUrl}/chuva/upload/mensagem/vista`;

  constructor(private socket: Socket, private http: HttpClient) { }

  /**
   * Faz upload das planilhas de chuva usando socket.io.
   * @param data ID do usuário e arquivos a serem carregados
   */
  uploadFile(data: { userId: number, files: { filename: string, content: File }[] }) {
    this.socket.emit('upload-rain-file', data);
    return this.socket.fromOneTimeEvent<any>('upload-rain-file');
  }

  /**
   * Usa conexão do socket.io para obter o progresso do upload das planilhas de chuva.
   * @param userId 
   */
  getUploadProgress(userId: number) {
    this.socket.emit(this.uploadProgressPath, { userId });
    return this.socket.fromEvent<RainUploadProgress>(this.uploadProgressPath);
  }

  /**
   * Marca o registro do progresso do upload das planilhas de chuva como visto, para evitar
   * que a mensagem fique aparecendo sempre que o usuário carregar a tela.
   * @param userId ID do usuário que fez o upload das planilhas
   * @return Observable do post http
   */
  markUploadMessageAsSeen(userId: number) {

    return this.http.post(this.updateUploadMessageUrl, { userId });
  }
}
